import {
  BULK_REQUEST_FETCH_DATA,
  BULK_REQUEST_ENABLE_LOADING,
  BULK_REQUEST_DISABLE_LOADING,
  BULK_REQUEST_FETCH_ERROR,
  BULK_REQUEST_SET_FILTERS,
  BULK_REQUEST_SET_PAGINATION,
  BULK_REQUEST_GET_RESET_FILTERS,
  BULK_REQUEST_RESET_PAGINATION,
  BULK_REQUEST_SET_PREV_PAGINATION,
  BULK_POLL_REQUEST_SUCCESS,
  BULK_POLL_REQUEST_ERROR,
  } from 'src/actions/constants';
import { arrayToObject } from 'src/utils/utils';
import { clone } from 'src/Library/Helper';

const defaultState = {
  isLoading: false,
  bulkRequestData: [],
  selectedFilters: {
    requestTypeList: [],
    userIdList: [],
    statusList: [],
    sortBy: 'created_at',
    lastSortedColumnValue: null,
    lastRowId: null,
    startDate: '',
    endDate: '',
    descendingOrder: true,
  },
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 50,
    nextOrPrev: 'first',
    lastSortedColumnValueNext : 0,
    lastSortedColumnValuePrev: 0,
    lastRowIdNext: 0,
    lastRowIdPrev: 0,
  },
  prevPagination : {
    currentPageNumber: 1,
    resultPerPage: 50,
    nextOrPrev: 'first',
    lastSortedColumnValueNext : 0,
    lastSortedColumnValuePrev: 0,
    lastRowIdNext: 0,
    lastRowIdPrev: 0,
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {

    case BULK_REQUEST_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case BULK_REQUEST_SET_FILTERS : {
      return {
        ...state,
        selectedFilters :{
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    case BULK_REQUEST_SET_PAGINATION : {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case BULK_REQUEST_DISABLE_LOADING : {
      return {
        ...state,
        isLoading : false,
      };
    }

    case BULK_REQUEST_GET_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
      };
    }

    case BULK_REQUEST_RESET_PAGINATION: {
      return {
        ...state,
        pagination: {
          currentPageNumber : 1,
          nextOrPrev: 'first',
          resultPerPage: state.pagination.resultPerPage,
        },
      };
    }
    case BULK_REQUEST_SET_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination,
      };
    }

    case BULK_REQUEST_FETCH_DATA : {
      return {
        ...state,
        bulkRequestData : action.data ? action.data.data : [],
        prevPagination : {
          ...state.pagination,
        },
        pagination : {
          ...state.pagination,
          currentPageNumber: action.data && action.data.currentPageNumber ||
            state.pagination.currentPageNumber,
          resultPerPage: action.data && action.data.resultPerPage ||
            state.pagination.resultPerPage,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext ||
            state.pagination.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev ||
            state.pagination.lastSortedColumnValuePrev,
          lastRowIdNext: action.data && action.data.lastItemIdNext ||
            state.pagination.lastRowIdNext,
          lastRowIdPrev: action.data && action.data.lastItemIdPrev ||
            state.pagination.lastRowIdPrev,
          isNextPresent: action.data && action.data.isNextPresent,
          nextOrPrev: action.data && action.data.nextOrPrev ||
            state.pagination.nextOrPrev,
        },
      };
    }

    case BULK_REQUEST_FETCH_ERROR : {
      return {
        ...state,
        errorMessage : action.data,
      };
    }

    case BULK_POLL_REQUEST_SUCCESS: {
      const bulkRequestData = clone(state.bulkRequestData);
      const bulkRequestDataMap = arrayToObject(bulkRequestData, 'id');
      const pollRequestDataMap = arrayToObject(action.data.data, 'id');
      Object.keys(pollRequestDataMap).forEach((key) => {
        bulkRequestDataMap[key] = {
          ...bulkRequestDataMap[key],
          totalRows: pollRequestDataMap[key].totalRows,
          successRows: pollRequestDataMap[key].successRows,
          otherRows: pollRequestDataMap[key].otherRows,
          errors: pollRequestDataMap[key].errors,
          pendingRows: pollRequestDataMap[key].pendingRows,
          status: pollRequestDataMap[key].status,
        };
      });
      const bulkRequestDataUpdated = Object.keys(bulkRequestDataMap)
        .map(key => bulkRequestDataMap[key]);
      return {
        ...state,
        bulkRequestData: bulkRequestDataUpdated.sort((a, b) => Number(b.id) - Number(a.id)),
      };
    }

    case BULK_POLL_REQUEST_ERROR: {
      return {
        ...state,
        errorMessage : action.data,
      };
    }

    default: return state;

  }
};
